<template>
<b-container
  class="py-5 d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container class="text-center" fluid>
	<b-row>
	  <b-col class="headline-wrapper">
	    <h1>Interested in News about Future TrinApps?</h1>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <div class="m-lg-5 px-lg-5">
	      <b-link
		href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
		target="_blank"
		>
		<b-img
		  :src="require('../assets/trinapp-future.png')"
		  style="max-width: 640px; width: 100%; height: auto;"
		  fluid
		  />
	      </b-link>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <b-button
	      size="lg"	
	      class="btn-orange my-5 mx-3"
	      href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	      target="_blank"
	      >
	      News Signup
	    </b-button>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <div class="fa-wrapper">
	      <b-link
		href="https://www.linkedin.com/company/graphmetrix"
		target="_blank"
		>
		<font-awesome-icon
		  :icon="faLinkedin"
		  class="fa-icon"
		  />
	      </b-link>
	    </div>
	    <div class="fa-wrapper">
	      <b-link
		href="https://www.youtube.com/channel/UCRxK7CYIGu4D3uHxWnSWbFA"
		target="_blank"
		>
		<font-awesome-icon
		  :icon="faYoutubeSquare"
		  class="fa-icon"
		  />
	      </b-link>
	    </div>
	    <div class="fa-wrapper">
	      <b-link
		href="https://vimeo.com/user97466398"
		target="_blank"
		>
		<font-awesome-icon
		  :icon="faVimeo"
		  class="fa-icon"
		  />
	      </b-link>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
</b-col>
  </b-row>
</b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLinkedin, faYoutubeSquare, faVimeo } from '@fortawesome/free-brands-svg-icons';
export default {
    name: "InterestedInNews",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
	    faLinkedin,
	    faYoutubeSquare,
	    faVimeo
	}
    }
}
</script>

<style>
.fa-wrapper {
    display: inline-block;
    padding-right: 16px;
}
.fa-icon:hover {
    color: #585aff;
}
.fa-icon {
    color: #656565;
    width: 40px !important;
    height: 40px !important;
}
</style>

<style scoped>
@media (max-width: 575px) {
	.headline-wrapper > h1 {
		font-size: 2rem !important;
	}
}
</style>
